import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=6da20c88&scoped=true&"
import script from "./LoadingDots.vue?vue&type=script&lang=ts&"
export * from "./LoadingDots.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingDots.vue?vue&type=style&index=0&id=6da20c88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da20c88",
  null
  
)

export default component.exports